import clsx from 'clsx';
import { useSelect } from '../hooks/useCoreContext';
import { AddIcon } from '@/legacy/components/ui/Icons';
import { Option } from '@/legacy/types';

type CreateRowProps = {
	index: number;
	labelPrefix?: string;
	className?: string;
};

const CreateRow = ({ index, labelPrefix = 'Create', className }: CreateRowProps) => {
	const { options, inputValue, highlightedIndex, handleCreateOption, getItemProps, listRef } =
		useSelect();

	const raw = inputValue.trim();
	if (!raw) return null;

	const normalize = (s: string) =>
		s
			?.normalize?.('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.toLowerCase() ?? s?.toLowerCase();

	const exists = options.some((o: Option) => normalize(o.label) === normalize(raw));
	if (exists) return null;

	const doCreate = async () => {
		await handleCreateOption?.(raw);
	};

	const highlighted = highlightedIndex === index;

	return (
		<li
			ref={(node) => {
				listRef.current[index] = node;
			}}
			tabIndex={highlighted ? 0 : -1}
			{...getItemProps()}
			onClick={() => {
				void doCreate();
			}}
			className={clsx(
				'px-4 py-2 cursor-pointer rounded flex items-center gap-2',
				highlighted ? 'bg-secondary-ultra-light' : 'hover:bg-secondary-ultra-light',
				className,
			)}
		>
			<AddIcon className={'text-icon-cuaternary'} />
			<span>
				{labelPrefix} “{raw}”
			</span>
		</li>
	);
};

export default CreateRow;
